import {showCopyableIdTooltip} from '@utils/eventDetailsHelper';

export const firstStageCategoryName = (event) => {
    return event.st_event?.stage?.id
        ? event.st_event.stage.stage_category?.parent?.name
        : event.st_event.stage_category?.parent?.name;
};

export const firstStageCategoryId = (event) =>
    event.st_event.stage?.stage_category?.parent?.id ?? event.st_event?.stage_category?.parent?.id;

export const firstStageCategory = (event) => showCopyableIdTooltip(
    firstStageCategoryName(event),
    firstStageCategoryId(event),
    'Stage category'
);
